import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  /**
   *
   * @param { date } query
   * @returns
   */
  getEarlyPayments(query) {
    return defaultClient.get(`/early-payments/early-payments?${qs.stringify(query)}`)
  },
  getRefunds(query) {
    return defaultClient.get(`/refund/refund/?${qs.stringify(query)}`)
  },
  getSalesSummary(query) {
    return defaultClient.get(`/early-payments/sales-summary?${qs.stringify(query)}`)
  },
  getSalesInfo(query) {
    return defaultClient.get(`/early-payments/sales/?${qs.stringify(query)}`)
  },
  getNewEarlyPayments(query) {
    return defaultClient.get(`/early-payments/?${qs.stringify(query)}`)
  },
  getCardDeliveryDeposits(query) {
    return defaultClient.get(`/early-payments/deposit-details/?${qs.stringify(query)}`)
  },
  getDailyAmount(query) {
    return defaultClient.get(`/early-payments/daily-amount?${qs.stringify(query)}`)
  },
  getSalesDailyTotal(query) {
    return defaultClient.get(`/early-payments/sales/daily-total?${qs.stringify(query)}`)
  },
  postEarlyPaymentsLoanRequests() {
    return defaultClient.post(`/early-payments/loan-requests/`)
  },
  // https://funda2015.postman.co/workspace/funda~2a3e2072-f6c8-429e-8184-a96e9525ef7f/request/6601624-983c94e2-ef7a-4ca8-9790-c9d0b9c47050?active-environment=89abe474-f222-440d-8096-a69bd7476701
  postEarlyPaymentsCallbackRequests(data) {
    return defaultClient.post(`/early-payments/callback-requests/`, data)
  },
  getPurchasementSummary(query) {
    return defaultClient.get(`/early-payments/purchasement-summary?${qs.stringify(query)}`)
  },
}
